/**
 * Strips HTML tags from a string and decodes HTML entities.
 * @param html The HTML string to strip.
 * @returns The plain text string.
 */
export const stripHtml = (html: string | null | undefined): string => {
  if (!html) return '';
  
  // Remove HTML tags
  const stripped = html.replace(/<[^>]*>?/gm, '');
  
  // Decode common HTML entities
  const decoded = stripped
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
    
  return decoded.trim();
};
